import { gql } from '@apollo/client';

export const GET_TRANSACTIONS = gql`
  query fetchMyTransactions($offset: Int!, $limit: Int!, $startAt: Date, $endAt: Date) {
    balance: niaga_seller_balance {
      total_due
      balance_signature
      can_request_balance
    }
    transactions: niaga_seller_transactions(
      filter: { offset: $offset, limit: $limit, where: { start_date: $startAt, end_date: $endAt } }
    ) {
      total_payment_received
      total_quantity_delivered
      transactions_list {
        id
        transaction_date
        party
        title
        statement_id
        source
        status
        type
        financials {
          estimated
          price_per_kg
          quantity
          total
          payment_state
          flow
        }
        debtor {
          firstname
          lastname
          organisation_name
          subdistrict
          transactor_id
          village
        }
        parent_contract_details {
          party
          statement_id
          contract_type
          buyer_organisation_name
        }
      }
    }
  }
`;
